<template>
  <div class="itemList">
    <div class="topBtnWrap">
      <div class="itemtitle">{{groupName}}</div>
    </div>
    <div class="itemContent">
      <div v-if="program.length !== 0">
        <div class="programs" v-for="(item,index) in program" :key="index">
          <div class="program-item">
            <div class="program-item-img">
              <img src="/static/images/1234.png" style="width: 100%;height: 100%;">
            </div>
            <div class="program-item-text overtext">
              <div class="program-item-name overtext">{{item.pmName}}</div>
              <div class="program-item-list">修改时间: {{item.createTime}}</div>
              <div class="program-item-list">分辨率: {{item.resolution}}</div>
              <div class="program-item-list">已关联任务: {{item.bindTaskNum}}</div>
              <div class="program-item-operate">
                <div class="program-item-btns"
                     @click="gotoa(`/createProrram`,{
                      id:item.id,
                      type:'edit'
                      })">
                  <i class="etv etvicon etv-bianji"></i>
                </div>
                <div class="program-item-btns" @click="gotoa(`/preview`,{
                      id:item.id
                      })">

                  <i class="etv etvicon etv-yulan"></i>
                </div>
                <div class="program-item-btns" @click="gotoa(`/addTask`,{
                      grogramIds:item.id,
                      parentPage:'taskList',
                      progremData: [item]
                      })">
                  <i class="etv etvicon etv-fasong"></i>
                </div>
                <div class="program-item-btns" @click="delprogram(item.id,index,item.bindTaskNum)">
                  <i class="etv etvicon etv-shanchu"></i>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="empty" v-if="program.length === 0">
        暂无数据
      </div>
    </div>
<!--    删除显示绑定的任务列表-->
    <van-popup v-model="isVisible1" position="bottom" custom-style="height: 20%" class="popupBottom">
      <van-row class="popupHead">
        <van-col :span="4">
          <van-button @click="isVisible1 = false" type="danger" size="small" class="popupHead-l" >
            取消
          </van-button>
        </van-col>
        <van-col :span="16" style="text-align: center">已绑任务</van-col>
        <van-col :span="4">
          <van-button @click="deleteConfirm" type="info" size="small"  class="popupHead-r" >
            删除
          </van-button>
        </van-col>
      </van-row>
      <div style="height:300px;overflow-y: auto;text-align: center" class="popupCenter">
        <div v-show="noData" class="nodataTxt">无数据</div>
        <van-row>
<!--          <van-col v-show="!noData" span="6">任务名称：</van-col>-->
          <van-col v-show="!noData" span="24" v-for="(item,index) in menuItems2" :key="index" >{{item.name}}</van-col>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import qs from 'qs'
  import { Dialog, Toast } from 'vant'

  export default {
    inject: ['reload'],
    data() {
      return {
        program: [],
        groupName: '',
        modal: false,
        button6: [{
          text: '取消',
          type: 'gray',
        }, {
          text: '确定',
        }],
        delObj: {
          id: '',
          index: 0,
        },
        groupId: 0,
        Pname: '',
        eventSign: 'click',
        contentTexe: '确定要删除节目吗?',
        isVisible1: false,
        menuItems2: [],
        noData: true,
      }
    },
    mounted() {
      this.getprogram()
      this.groupName = this.$route.query.name
    },
    methods: {
      ...mapActions(['changeTopTitle', 'changeTopIconStatus', 'setParentPage']),
      getprogram() {
        this.$ajax.post('/etv/selectPhoneLstProgramMould.json', qs.stringify({
          pcId: this.$route.query.id,
          state: 0,
          pageSize: 12,
          pageNum: 1,
          name: '',
        })).then(res => {
          if (res.data.code === 0) {
            this.program = res.data.data
          }
        })
      },
      // eslint-disable-next-line no-unused-vars
      goto(url) {

      },

      gotoa(url, query) {
        this.$router.push({
          path: url,
          query,
        })
        if (url == '/addTask') {
          this.changeTopTitle('添加任务')
          this.setParentPage('programs')
          this.changeTopIconStatus(true)
        }
      },

      // delprogram(id, index, number) {
      delprogram(id) {
        let _this = this
        _this.isVisible1 = true
        _this.delObj.id = id
        this.$ajax.post('/etv/selectProgramMouldBindEqtask.json',qs.stringify({
          id: id
        })).then(res => {
          if(res.data.data.length > 0){
            _this.noData = false
            _this.menuItems2 = res.data.data
          }else{
            _this.noData = true
          }
        })

      },
      deleteConfirm(){
          let contentTexe = '是否确定删除该节目？'
          this.isVisible1 = false
          // if (number !== 0) {
          //   contentTexe = '已绑定任务，确定要删除吗?'
          // } else {
          //   contentTexe = '确定要删除节目吗?'
          // }
          // this.delObj = {
          //   id,
          //   index,
          // }


          Dialog.confirm({
            title: '提示',
            message: contentTexe,
          }).then(() => {
            this.$ajax.post('/etv/deleteProgramMouldById.json', qs.stringify({
              id: this.delObj.id,
            })).then(res => {
              if (res.data.code === 0) {
                Toast('删除成功')
                this.reload()
              } else {
                Toast('删除失败')
              }
            })
          }).catch(() => {
            // on cancel
          })
      },
      hide() {
        this.modal = false
      },

    },
    computed: {
      ...mapState({
        progranList: state => state.progranList,
      }),
    },
  }
</script>

<style lang="scss">
  @import "../../public/static/css/app";

  .itemList {
    position: absolute;
    left: 0;
    top: 0px;
    right: 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    overflow: hidden;

    .popupBottom{
      .popupHead{
        height:40px;line-height:40px;border-bottom:1px solid #ddd;
        .popupHead-l{
          width:100%;background:none;color:#EE0A24;border:none;line-height:40px;height:40px;text-indent: -4px;
        }
        .popupHead-r{
          width:100%;background:none;color:#1B89FA;border:none;line-height:40px;height:40px;text-indent: -4px;
        }
      }
      .popupCenter{
        min-height:150px;max-height:200px;overflow-y: auto;text-align: center;padding:0 20px;
        .van-col{
          text-align: center;width:100%;height:40px;line-height:40px;border-bottom:1px solid #ddd;
        }
        .nodataTxt{
          margin-top:30%;
          width:100%;
          text-align: center;
        }
      }
    }



    .topBtnWrap {
      display: flex;
      justify-content: center;
      width: 100%;

      .itemtitle {
        display: flex;
        flex: 1;
        justify-content: center;
        margin: 0;
        height: 45px;
        line-height: 45px;
        background: #FFF;

        color: #000;
      }
    }

    .itemContent {
      height: calc(100% - 45px);
      overflow-y: auto;
      width: 100%;
    }

    .empty {
      height: 100px;
      width: 100%;
      text-align: center;
      line-height: 100px;
      color: #8c8c8c;
    }

    .programs {
      padding: 10px;
      width: 100%;
      box-sizing: border-box;
      background: $uni-text-color-inverse;
      margin-top: 13px;

      .program-item {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        border-radius: 5px;

        .program-item-img {
          height: 123px;
          width: 110px;
          box-sizing: border-box;
        }

        .program-item-text {
          flex: 1;
          padding-left: 15px;
          box-sizing: border-box;

          .program-item-name {
            height: 20px;
            border-bottom: 2 upx solid $uni-border-bottom-color;
            color: #007AFF;
            font-size: 14px;
            margin-bottom: 5px;
          }

          .program-item-list {
            height: 20px;
            line-height: 20px;
            font-size: 14px;
            margin: 2px 0;
            color: $uni-text-color-placeholder;
          }

          .program-item-operate {
            display: flex;
            justify-content: space-between;
            width: 150px;
            margin-top: 9px;

            .program-item-btns {
              height: 24px;
              width: 24px;
              display: flex;
              justify-content: center;
              align-items: center;
              border: 1px solid #e7e7e8;
              border-radius: 3px;

              text {
                color: #6b6b6b;
              }
            }
          }
        }
      }

    }
  }
</style>
